import { VisualisationOption } from 'dashboard-engine/types/Visualisation';
import { ColumnDropdown } from '../sharedComponents/ColumnDropdown';
import { DataStreamIframeConfig } from './Config';
import { findIframeLinkColumn, matchesData } from './dataUtils';

const DataStreamIframeOptions: VisualisationOption<DataStreamIframeConfig> = {
    initialPanels: () => [{ name: 'mapping', isOpen: true }],
    dataMappingComponent: ({ columns, config, onChange }) => (
        <>
            <ColumnDropdown
                label='URL'
                name='linkColumn'
                help='Select the column to use as the embedded URL'
                columns={columns}
                defaultColumn={findIframeLinkColumn(columns)}
                config={config}
                onChange={onChange}
            />
        </>
    ),
    handlers: {
        'linkColumn-select': (config, data) => {
            return {
                ...config,
                linkColumn: data
            };
        }
    },
    validate: (_, config, defaultConfig) => {
        return {
            ...config,
            linkColumn:
                config.linkColumn === 'auto' || !config.linkColumn
                    ? defaultConfig?.linkColumn ?? config.linkColumn
                    : config.linkColumn
        };
    },
    matchesData,
    getDefaultConfig(data) {
        // Default configuration with sensible defaults
        const defaultConfig: DataStreamIframeConfig = {
            scale: 1
        };

        if (!data || !data.metadata || !data.metadata.columns || data.metadata.columns.length === 0) {
            return defaultConfig;
        }

        const columns = data.metadata.columns;

        // Find appropriate URL column
        const linkColumn = findIframeLinkColumn(columns);

        if (linkColumn.succeeded) {
            defaultConfig.linkColumn = linkColumn.value.column.name;

            // Optionally set a title based on the first string column that's not the URL
            const titleColumn = columns.find(
                (col) => col.shapeName.includes('string') && col.name !== linkColumn.value.column.name
            );

            if (titleColumn) {
                defaultConfig.title = titleColumn.displayName;
            }
        }

        return defaultConfig;
    }
};

export default DataStreamIframeOptions;
